import {Component, EventEmitter, Input, Output, ChangeDetectionStrategy} from '@angular/core';
import {BicInputComponent} from '@buildinginformationcloud/bic-ui-components';
import {JsonSchema} from '../schema-form.types';

/**
 * string → text input (bic-input).
 *
 * `type` wird gebunden statt als Attribut gesetzt: ein statisches `type="text"` landet als echtes
 * HTML-Attribut auf dem Custom Element, und @tailwindcss/forms gibt jedem `[type='text']` ein
 * Padding von .5rem/.75rem – das Feld säße dann sichtbar eingerückt gegenüber seinem Label.
 */
@Component({
  selector: 'sf-input',
  standalone: true,
  imports: [BicInputComponent],
  changeDetection: ChangeDetectionStrategy.Eager,
  template: `
    <bic-input
      class="w-full"
      [type]="'text'"
      [value]="value ?? ''"
      [placeholder]="placeholder"
      [disabled]="disabled"
      [showX]="false"
      (valueChange)="valueChange.emit($event)">
    </bic-input>
  `,
})
export class SfInputComponent {
  @Input() schema: JsonSchema | null = null;
  @Input() value: any;
  /** Read-only, z.B. weil die Zeile vom Modul verwaltet wird (siehe `x-managed-items`). */
  @Input() disabled = false;
  @Output() valueChange = new EventEmitter<any>();

  get placeholder(): string {
    return this.schema?.['x-placeholder'] ?? 'Wert eingeben…';
  }
}
